/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { EntitlementType } from './entitlement-type';
import { LocalizedFieldBody } from './localized-field-body';
import { TargetPlatform } from './target-platform';
import { UiModuleExperimentGroup } from './ui-module-experiment-group';

/**
 * 
 * @export
 * @interface AccountLoadingUiModuleBody
 */
export interface AccountLoadingUiModuleBody {
    /**
     * 
     * @type {string}
     * @memberof AccountLoadingUiModuleBody
     */
    moduleId?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountLoadingUiModuleBody
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountLoadingUiModuleBody
     */
    hash?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountLoadingUiModuleBody
     */
    moduleType: AccountLoadingUiModuleBodyModuleTypeEnum;
    /**
     * 
     * @type {Array<TargetPlatform>}
     * @memberof AccountLoadingUiModuleBody
     */
    targetPlatform?: Array<TargetPlatform>;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof AccountLoadingUiModuleBody
     */
    caption?: LocalizedFieldBody;
    /**
     * 
     * @type {Array<EntitlementType>}
     * @memberof AccountLoadingUiModuleBody
     */
    entitlements?: Array<EntitlementType>;
    /**
     * 
     * @type {Array<UiModuleExperimentGroup>}
     * @memberof AccountLoadingUiModuleBody
     */
    experiments?: Array<UiModuleExperimentGroup> | null;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof AccountLoadingUiModuleBody
     */
    title: LocalizedFieldBody;
    /**
     * 
     * @type {string}
     * @memberof AccountLoadingUiModuleBody
     */
    accountLoading: string;
}

/**
    * @export
    * @enum {string}
    */
export enum AccountLoadingUiModuleBodyModuleTypeEnum {
    ACCOUNT_LOADING = 'ACCOUNT_LOADING'
}



